import applicationStore from "../../ApplicationStore";
import RestClient from "../../../integration/RestClient";
import { ActionType } from "../../actions";
import { METHOD_TYPES } from "../../../utils/Constants";
import { ApiBookingTolerancesBookingTolerancesFormDataGetRequest, BookingTolerancesFormData } from "../../../integrated-client";

export class BookingTolerancesEditorActions {

  public static async getData(data:ApiBookingTolerancesBookingTolerancesFormDataGetRequest, removeId: boolean = false) {
    const result = await RestClient.bookingTolerances.form.apiBookingTolerancesBookingTolerancesFormDataGet(data);
    if (result.hasOwnProperty("id")) {
      applicationStore.dispatch({
        type: removeId ? ActionType.BOOKING_TOLERANCES_EDITOR_DATA_COPIED : ActionType.BOOKING_TOLERANCES_EDITOR_DATA_FETCHED,
        data: {...result}
      });
    }
  }
  
  public static async saveData(data?: BookingTolerancesFormData, type: METHOD_TYPES = METHOD_TYPES.POST) {
    const preparedDataToServer = {
      ...data,
      applicationType: data?.applicationType ? (data as any)?.applicationType?.applicationType : null
    };
    const saveMethod = type === METHOD_TYPES.POST ? 'apiBookingTolerancesBookingTolerancesFormCreatePost' : 'apiBookingTolerancesBookingTolerancesFormUpdatePost';
    if(saveMethod === 'apiBookingTolerancesBookingTolerancesFormCreatePost')
    {
      await RestClient.bookingTolerances.form[saveMethod]({ bookingTolerancesCreateRequest: preparedDataToServer });
      applicationStore.dispatch({ type: ActionType.VCC_CREDENTIALS_EDITOR_DATA_SAVED });
      return;
    }
    else if(saveMethod === 'apiBookingTolerancesBookingTolerancesFormUpdatePost')
    {
      await RestClient.bookingTolerances.form[saveMethod]({ bookingTolerancesUpdateRequest: preparedDataToServer });
      applicationStore.dispatch({ type: ActionType.VCC_CREDENTIALS_EDITOR_DATA_SAVED });
      return;
    }
  }
  
  public static async validateData(data?: BookingTolerancesFormData) {
    const preparedDataToServer = {
      ...data,
      applicationType: data?.applicationType ? (data as any)?.applicationType?.applicationType : null
    };
    const errors = await RestClient.bookingTolerances.form.apiBookingTolerancesBookingTolerancesFormValidatePost({
      bookingTolerancesFormData: preparedDataToServer
    });
    applicationStore.dispatch({ type: ActionType.BOOKING_TOLERANCES_EDITOR_DATA_VALIDATED, data: {...errors} });
    return { ...errors }
  }

  public static updateData(data: any) {
    applicationStore.dispatch({ type: ActionType.BOOKING_TOLERANCES_EDITOR_DATA_UPDATED, data });
  }

  public static resetData() {
    applicationStore.dispatch({ type: ActionType.BOOKING_TOLERANCES_EDITOR_DATA_RESET });
  }

  public static setBoundItem(data: any){
    applicationStore.dispatch({ type: ActionType.BOOKING_TOLERANCES_EDITOR_SET_BOUND_ITEM, data });
  }
  
}

